import { Box } from "@material-ui/core";
import { Form, Formik, FormikHelpers } from "formik";
import React from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../../../api/service/service.types";
import { FormikTextField } from "../../../../../../components/FormikFields";

type TValuationNotesForm = {
  notesDuringValuation: string;
};

const StyledWrapper = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0.75rem 1rem;
`;

const StyledForm = styled(Form)`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledInputWrapper = styled(Box)`
  flex-grow: 1;
  overflow: hidden;
  padding-bottom: 1rem;

  > div {
    height: 100%;

    .MuiFormControl-root {
      height: 100%;
    }

    .MuiOutlinedInput-root {
      height: 100%;
      display: block;
    }

    .MuiOutlinedInput-inputMultiline {
      height: 100%;
      max-height: 100%;
    }
  }
`;

interface IValuationNotesProps {
  service: TGetServicesCollectionItem;
  onValuationNotesChange: (notes: string) => void;
  valuationNotes: string;
}

const ValuationNotes = (props: IValuationNotesProps) => {
  const { service, onValuationNotesChange } = props;
  const { formatMessage } = useIntl();

  const handleFormSubmit = async (
    values: TValuationNotesForm,
    actions: FormikHelpers<TValuationNotesForm>
  ) => {};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onValuationNotesChange(e.target.value);
  };

  const initialValues: TValuationNotesForm = {
    notesDuringValuation: service.notesDuringValuation ?? "",
  };

  return (
    <StyledWrapper>
      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {(props) => (
          <StyledForm>
            <StyledInputWrapper>
              <FormikTextField
                margin="nomargin"
                name="notesDuringValuation"
                onChange={handleChange}
                multiline
                placeholder={formatMessage({
                  id: "ValuationNotes.Placeholder",
                  defaultMessage:
                    "Escribe aquí cualquier cosa que quieras mientras haces la valoración. Estas notas se eliminarán al completar la valoración",
                })}
              />
            </StyledInputWrapper>
          </StyledForm>
        )}
      </Formik>
    </StyledWrapper>
  );
};

export default ValuationNotes;
